
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { Payments } from './dto/payments.entity';
import { Repository } from 'typeorm';
import { PaymentsDTO } from './dto/payments-dto';
import { CommonResponseModel, ItemEnum, PaymentIdRequest, PaymentsStatusEnum, UploadResponse } from '@project-management-system/shared-models';
import { PaymentUploads } from './dto/payment-uploads.entity';
@Injectable()
export class PaymentsService {
    constructor(
        @InjectRepository(Payments)
        private paymentsRepository: Repository<Payments>,
        @InjectRepository(PaymentUploads)
        private paymentUploadsRepo: Repository<PaymentUploads>,

      ){}

      async createPayment(paymentsDTO: PaymentsDTO, isUpdate: boolean): Promise<CommonResponseModel>{
        try{
          console.log(paymentsDTO)
          const today = new Date();
          const CurrentYear = today.getFullYear();
          const CurrentMonth = today.getMonth();
          let fromDate = 0;
          let toDate = 0;
          if(!isUpdate){
            const PaymentMethodEntity = await this.paymentsRepository.findOne({where:{poId:paymentsDTO.poId,grnId:paymentsDTO.grnId}});
            if (PaymentMethodEntity){
              throw new CommonResponseModel(false,11104, 'Payment already exists'); 
            }
          }

          const data = 'select max(ref_no) as poId from payments where material_type = "'+paymentsDTO.materialType+'"';
          let totalPO = await this.paymentsRepository.query(data)
        // if (!isUpdate) {
            if (CurrentMonth < 4) {
                fromDate = (CurrentYear-1);
                toDate = (CurrentYear);
            } else {
                fromDate = (CurrentYear);
                toDate = (CurrentYear + 1);
            }

        // }
        
        let val = totalPO[0].poId + 1;


        let refNo = val + "";
        while (refNo.length < 4) refNo = "0" + refNo;

        let materialType
        if(paymentsDTO.materialType === ItemEnum.Fabric){
          materialType = "F";
        }
        else if(paymentsDTO.materialType === ItemEnum.Trim){
          materialType = "T";
        }
        let paymentCode = "PAY/" + (fromDate.toString().substr(-2)) + "-" + (toDate.toString().substr(-2)) + "/" + materialType + "/" + refNo;

        
          let entity = new Payments()
          entity.controlNumber = paymentsDTO.controlNumber;
          entity.grnId = paymentsDTO.grnId;
          entity.materialType = paymentsDTO.materialType;
          entity.status = paymentsDTO.status;
          entity.paymentCode = paymentCode;
          entity.poId = paymentsDTO.poId;
          entity.invoiceAmount = paymentsDTO.invoiceAmount;
          entity.refNo = val;
          let saveEntity = await this.paymentsRepository.save(entity);
        if (saveEntity) {
          const response = new CommonResponseModel(true,1000,'Payment Request Created Successfully. ',saveEntity);
          return response;
        } else {
          return new CommonResponseModel(false,11106,'Something went wrong. ');
        }
      } catch (error) {
        return error;
      }
    }

    async getAllPaymentsRequests(): Promise<CommonResponseModel>{
      try{
        let data = await this.paymentsRepository.find({relations:["purchaseOrderEntity","grnEntity"],where:{isActive:true},order:{controlNumber:'DESC'}});
        if(data.length > 0){
          return new CommonResponseModel(true,1,"All payments retrived successfully. ",data);
        }
        else{
          return new CommonResponseModel(false,0,"No data found. ",data);
        }
      }catch (error) {
        return error;
      }
    }

    async uploadPaymentDocs(filePath: any, paymentId: any): Promise<UploadResponse> {
      console.log(filePath);
      console.log("********************************")
      console.log(paymentId);
      console.log(paymentId.paymentId);


      try {
        let flag = false
        for(const file of filePath){
          console.log("hhh")
          let entity = new PaymentUploads()
          entity.fileName = file.originalname;
          entity.filePath = file.path;
          const pay = new Payments()
          pay.paymentsId = paymentId.paymentId;
          entity.payments = pay;
          console.log(entity);
          let save = await this.paymentUploadsRepo.save(entity);
          console.log(save)
          if(save.uploadId > 0){
            flag = true
          }
        }
        if(!flag){
          return new UploadResponse(false,0,"Something went wrong. ",undefined);
        }
        else{
          return new UploadResponse(true,1,"Upload Successfully.  ",undefined);
        }
      }catch (error) {
        return error;
      }
    }
  
    async updatePaymentStatus(req:PaymentIdRequest): Promise<CommonResponseModel>{
      try{
        let data = await this.paymentsRepository.update({paymentsId:req.paymentsId},{status:PaymentsStatusEnum.Received});
        if(data.affected > 0){
          return new CommonResponseModel(true,1,"Payment Status updated successfully. ",data);
        }
        else{
          return new CommonResponseModel(false,0,"No data found. ",data);
        }
      }catch (error) {
        return error;
      }
    }
}